var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ ..._vm.$route, hash: '#language' }}},[_c('icon',{attrs:{"src":require("@/assets/icons/language.svg")}}),_c('span',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.$options.languages[_vm.$i18n.locale])+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }